// Dependencies
import React, { Component } from 'react';
import {
  View,
  TouchableOpacity,
} from 'react-native';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Config from '../../libraries/ReactNativeConfig';
import { debounce } from 'lodash';
import { AnimatedCircularProgress } from 'react-native-circular-progress';
import styles from './styles';
import withNavigation from '../../utils/WithNavigation';
import Utility from '../../utils/Utility';
import {
  showImageProgressBar,
  showPopover,
  getUserFacialAttributes,
  selfieAnalysisState,
  imageUploadPercentage,
} from '../../actions/LoginActions';
import colors from '../../theme/Colors';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import FastImageView from '../FastImageView';
import { MoEReactInbox } from '../../libraries/ReactMoe';
import AppConfig from '../../config/AppConfig';
import DebouncedTouchableOpacity from '../shared/DebouncedTouchableOpacity';
import withProfiledNavigation from '../../utils/withProfiledNavigation';
import { getNavigationSource } from '../../utils/PerfUtility';
import { TABBAR_CONSTANT } from '../../config/Constants';

class TabNavigationLeftHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopover: false,
      popoverMessage: '',
      popoverActionsButtonText: '',
      showNotificationIndication: false,
    };

    this.isErrorSet = false;
    this.isFeedTab = false;
    this.errorWhileTakingSelfie = false;

    this.debouncedProfileNavigate = debounce(this.onProfileTap, 1000, {
      leading: true,
      trailing: false,
    });
    this.navigationSource = getNavigationSource(this, this.props);
  }

  componentDidMount() {
    const { navigation } = this.props;
    this.unsubscribe = navigation.addListener('focus', () => {
      this.onFocus();
    });
  }

  componentDidUpdate(prevProps) {
    const {
      selfieImageUrl,
      authToken,
      facialAnalysis: { uploadPercentage, currentState, showPopOver },
      navigation,
    } = this.props;

    if (
      Utility.invokeSelfiePromptAfterLogin &&
      Utility.isBlank(prevProps.authToken) &&
      Utility.isPresent(authToken)
    ) {
      if (Utility.isBlank(selfieImageUrl)) {
        navigation.navigate(SCREEN_CONSTANTS.SELFIE_INTRO);
        Utility.invokeSelfiePromptAfterLogin = false;
      }
    }

    if (
      prevProps.facialAnalysis.uploadPercentage !== 100 &&
      uploadPercentage === 100
    ) {
      this.hideProgressBar();
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  onFocus = () => {
    this.setNotificationCount();
  };

  setNotificationCount = async () => {
    if (Utility.isWeb()) return;
    const count = (await MoEReactInbox.getUnClickedCount()) || 0;
    const { showNotificationIndication } = this.state;
    const showIndication = count > 0;
    if (showIndication !== showNotificationIndication) {
      this.setState({
        showNotificationIndication: showIndication,
      });
    }
  };

  showPopover = (message, buttonText) => {
    this.setState({
      showPopover: true,
      popoverMessage: message,
      popoverActionsButtonText: buttonText,
    });
  };

  handleTap = () => {
    const { showCart } = this.props;
    if (showCart) {
      this.props.toggleCartVisibility();
    }
  };

  onProfileTap = () => {
    const { navigation, authToken, phoneNumberModalTitle, selfieImageUrl } =
      this.props;
    if (AppConfig.getBooleanValue(Config.INTERCEPT_PROFILE_PIC_ROUTE)) {
      navigation.navigate(Config.PROFILE_PIC_ROUTE);
      return;
    }
    navigation.push(this.navigationSource, 'ConsumerProfile', {});
  };

  progressBar = (props) => {
    const { percentage } = props;
    const { size, tabBar, disableButton = false } = this.props;
    let fill = !percentage ? 0 : percentage;

    return (
      <TouchableOpacity
        style={
          size === 'large' ? styles.largeProgressBar : tabBar === TABBAR_CONSTANT.listTab ? styles.listTabSmallProgressBar : styles.smallProgressBar
        }
        onPress={this.debouncedProfileNavigate}
        disabled={disableButton}
      >
        <AnimatedCircularProgress
          size={size === 'large' ? 56 : 35}
          width={3}
          fill={fill}
          rotation={0}
          tintColor={colors.green}
          backgroundColor={colors.silverLit}
        />
      </TouchableOpacity>
    );
  };

  hideProgressBar = () => {
    const { showImageProgressBar } = this.props;
    showImageProgressBar(false);
  };

  closePopover = () => {
    const { showPopover } = this.props;
    this.setState({ showPopover: false });
    this.hideProgressBar();
    showPopover('hidden');
  };

  navigateToSelfie = () => {
    const { navigation, facialAnalysis, showPopover } = this.props;
    const { popoverActionsButtonText } = this.state;
    this.isErrorSet = false;
    this.closePopover();

    if (this.errorWhileTakingSelfie) {
      navigation.navigate('AttributeSelector', {
        previousScreen: SCREEN_CONSTANTS.SELFIE_CARD,
      });
    } else {
      showPopover('hidden');
      navigation.navigate('AttributeSelector', {});
    }
  };

  profilePic = () => {
    const {
      imageUrl,
      tabBar,
      instagram_profile,
      selfieImageUrl,
      size = 'small',
      image_uri,
      fallbackSelfieImage,
    } = this.props;
    this.isFeedTab = true;

    const imageSource =
      Utility.currentProfilePicToShowString(
        selfieImageUrl,
        instagram_profile,
        imageUrl,
        size,
        fallbackSelfieImage,
      ) || image_uri;

    let profileIconStyle = size === 'small'
      ? styles.navbarProfileIconStyle
      : styles.navbarProfileIconStyleLarge;

    if (tabBar === TABBAR_CONSTANT.listTab) {
      profileIconStyle = styles.navbarProfileIconStyleListTab;
    }

    return (
      <FastImageView
        testID='profile-icon'
        accessibilityLabel='profile-icon'
        source={imageSource}
        style={profileIconStyle}
        resizeMode='cover'
        enableProfilePicPlaceholder={Utility.isBlank(imageSource)}
      />
    );
  };

  render() {
    const {
      tabBar,
      email = '',
      size = 'small',
      disableButton = false,
      selfieAnalysis = {},
    } = this.props;

    const { showNotificationIndication } = this.state;

    const showIndication = Utility.isBlank(email) || showNotificationIndication;

    if (AppConfig.getBooleanValue(Config.DISABLE_PROFILE_IN_FEED_HEADER)) {
      return null;
    }
    const profileIconIndicatorStyle = (tabBar === TABBAR_CONSTANT.listTab)
      ? styles.profileIconIndicatorListTab
      : styles.profileIconIndicator;

    return (
      <DebouncedTouchableOpacity
        style={
          size === 'small'
            ? styles.leftNavbarHeaderStyle
            : styles.leftNavbarHeaderStyleLarge
        }
        onPress={this.debouncedProfileNavigate}
        hitSlop={Utility.getHitSlop('my_profile')}
        disabled={disableButton}
      >
        <this.profilePic />
        {selfieAnalysis?.show_progress_around_pic && (
          <this.progressBar percentage={selfieAnalysis?.analysis_progress} />
        )}
        {showIndication && size === 'small' && (
          <View style={profileIconIndicatorStyle} />
        )}
      </DebouncedTouchableOpacity>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  imageUrl: state.UserAccountInfo.profile.image_url,
  selfieImageUrl: state.UserAccountInfo?.selfieAnalysis?.selfie_image,
  instagram_profile: state.UserAccountInfo.instagram_profile,
  authToken: state.UserAccountInfo.authToken,
  facialAnalysis: state.UserAccountInfo.facialAnalysis,
  email: state.UserAccountInfo.profile.email,
  selfieAnalysis: state.UserAccountInfo?.selfieAnalysis,
  fallbackSelfieImage: state.UserAccountInfo?.saveSelfieImage?.selfie_url,
});

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      showImageProgressBar,
      showPopover,
      getUserFacialAttributes,
      selfieAnalysisState,
      imageUploadPercentage,
    },

    dispatch,
  ),
});

export default withProfiledNavigation(
  connect(mapStateToProps, mapDispatchToProps)(TabNavigationLeftHeader),
);
